import { parseISO, differenceInMonths } from 'date-fns';

// Parse an ISO date string; an empty/absent end date means "now" (ongoing).
export function toDate(dateString) {
  if (!dateString) return new Date();
  return parseISO(dateString);
}

// Whole months between a start date and an end date (or now when ongoing).
export function monthsBetween(startDate, endDate) {
  const months = differenceInMonths(toDate(endDate), toDate(startDate));
  return Math.max(0, months) + 1; // inclusive of the starting month
}

// Human-friendly duration, e.g. "2 jaar 3 mnd" (nl) / "2 yrs 3 mos" (en).
export function formatDuration(months, language) {
  const years = Math.floor(months / 12);
  const rem = months % 12;
  const parts = [];
  if (language === 'en') {
    if (years) parts.push(`${years} ${years === 1 ? 'yr' : 'yrs'}`);
    if (rem || !years) parts.push(`${rem} ${rem === 1 ? 'mo' : 'mos'}`);
  } else {
    if (years) parts.push(`${years} ${years === 1 ? 'jaar' : 'jaar'}`);
    if (rem || !years) parts.push(`${rem} mnd`);
  }
  return parts.join(' ');
}

// Map a resume "level" to a 0-5 numeric value for charts.
export function levelToValue(level) {
  if (!level) return 2;
  const l = level.toLowerCase();
  if (l.startsWith('gevorderd') || l.startsWith('advanced') || l.startsWith('expert')) return 5;
  if (l.startsWith('gemiddeld') || l.startsWith('intermediate')) return 3.5;
  return 2; // beginner / everything else
}
